import { FunctionComponent, ReactElement } from 'react';

import { TooltipStyled } from './styled';

export type Props = {
    text: string | ReactElement;
    children: ReactElement;
    placement?: 'bottom' | 'top' | 'left' | 'right';
};

const InformationTooltip: FunctionComponent<Props> = ({
    text,
    children,
    placement = 'bottom'
}: Props) => {

    return (
        <TooltipStyled title={text} arrow placement={placement}>
            {children}
        </TooltipStyled>
    );
};

export default InformationTooltip;
